// extracted by mini-css-extract-plugin
module.exports = {"bolt-modal":"Modal_bolt-modal__iKBOr","close":"Modal_close__pdNHA","title":"Modal_title__xU6yq","content":"Modal_content__epKJO"};